"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Services_1 = __importDefault(require("../Services"));
const lodash_1 = __importDefault(require("lodash"));
class Shipping {
    main() {
        this.initShipmentTypes();
        this.initSelectedShipmentTypes();
    }
    initShipmentTypes() {
        const $wrapper = $(document).find('.js-shipment-type-wrapper');
        const $items = $wrapper.find('input.js-shipment-type-item');
        $items.on('input change', function () {
            const $this = $(this);
            if ($this.is(':checked')) {
                const $summary_total_amount = $(document).find('.js-total-amount-payable');
                let cost = 'کرایه در مقصد';
                let total_amount = Services_1.default.formatCurrency(lodash_1.default.toNumber($this.data('cost')) + lodash_1.default.toNumber($summary_total_amount.data('total-amount'))) + ' <svg class="currency-symbol"><use xlink:href="#toman"></use></svg> ';
                if ($this.data('method') === 'online-payment') {
                    cost = (Services_1.default.formatCurrency($this.data('cost')) + ' <svg class="currency-symbol"><use xlink:href="#toman"></use></svg> ');
                }
                const data = {
                    shipment_cost: {
                        value: cost,
                        title: $this.data('title'),
                        delivery_internal: $this.data('delivery-internal'),
                    },
                    total_amount: {
                        value: total_amount
                    }
                };
                Shipping.reloadSummary(data.shipment_cost, data.total_amount);
            }
        });
    }
    initSelectedShipmentTypes() {
        const $item = $(document).find('input.js-shipment-type-item:checked');
        if ($item.length) {
            const $summary_total_amount = $(document).find('.js-total-amount-payable');
            let cost = 'کرایه در مقصد';
            let total_amount = Services_1.default.formatCurrency(lodash_1.default.toNumber($item.data('cost')) + lodash_1.default.toNumber($summary_total_amount.data('total-amount'))) + ' <svg class="currency-symbol"><use xlink:href="#toman"></use></svg> ';
            if ($item.data('method') === 'online-payment') {
                cost = (Services_1.default.formatCurrency($item.data('cost')) + ' <svg class="currency-symbol"><use xlink:href="#toman"></use></svg> ');
            }
            const data = {
                shipment_cost: {
                    value: cost,
                    title: $item.data('title'),
                    delivery_internal: $item.data('delivery-internal'),
                },
                total_amount: {
                    value: total_amount
                }
            };
            Shipping.reloadSummary(data.shipment_cost, data.total_amount);
        }
    }
    static reloadSummary(shipment_cost, total_amount) {
        const total_amount_summary = $(document).find('.js-total-amount-payable');
        total_amount_summary.fadeOut('fast', function () {
            total_amount_summary
                .html(total_amount.value.toString())
                .fadeIn('fast');
        });
        const shipment_cost_summary = $(document).find('.js-checkout-summary-price-list .js-shipment-cost');
        shipment_cost_summary.fadeOut('fast', function () {
            shipment_cost_summary
                .html(shipment_cost.value.toString())
                .fadeIn('fast');
        });
        $(document)
            .find('.js-shipment-type-title')
            .fadeOut('fast', function () {
            $(this)
                .html(shipment_cost.title)
                .fadeIn('fast');
        });
        $(document)
            .find('.js-shipment-type-delivery-internal')
            .fadeOut('fast', function () {
            $(this)
                .html(shipment_cost.delivery_internal)
                .fadeIn('fast');
        });
    }
}
exports.default = Shipping;
